import * as React from 'react';
const SvgDraftIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.665 4.583c0-1.63 1.3-2.916 2.928-2.916h7.626c1.01 0 1.883.447 2.515 1.076l2.493 2.479c.783.68 1.105 1.587 1.105 2.528v7.667c0 1.631-1.3 2.916-2.929 2.916h-1.34a.833.833 0 0 1-.834-.833v-4.083c0-.286-.209-.5-.507-.5H8.275a.487.487 0 0 0-.508.5v3.25h4.698a.833.833 0 0 1 0 1.666H5.593c-1.606 0-2.928-1.263-2.928-2.833V4.583Zm3.436 12.084h-.508c-.74 0-1.261-.57-1.261-1.167V4.583c0-.702.544-1.25 1.261-1.25h7.626c.498 0 .966.22 1.34.591l2.514 2.5c.015.015.03.03.047.044.37.316.545.734.545 1.282v7.667c0 .702-.544 1.25-1.262 1.25h-.507v-3.25a2.153 2.153 0 0 0-2.174-2.167H8.275c-1.21 0-2.174.952-2.174 2.167v3.25Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDraftIcon;
